import * as React from "preact";
import { render } from "preact";

import App from "./App";

/* istanbul ignore next */
function init() {
  const elements = Array.from(document.getElementsByClassName("dividend-calculator-app")) as HTMLElement[];

  elements.forEach((el) => {
    const { dividendData } = el.dataset;

    try {
      const data = dividendData ? JSON.parse(dividendData) : undefined;
      render(<App countries={data} />, el);
    } catch (err) {
      console.log("Can not render calculator form = " + err);
    }
  });
}

export default { init };
